import css from '@emotion/css';
import { styled, pxToRem } from '@feast-it/ui/light';

// Color cycling for pills
const COLORS = [
  '#D4E6A8',
  '#AFD5E7',
  '#FFD4CD',
  '#FFEBB3',
  '#DCCEBB',
  '#FFC69C',
];

export const Pill = styled.div`
  --color: ${COLORS[0]};

  &:nth-of-type(2n) {
    --color: ${COLORS[1]};
  }

  &:nth-of-type(3n) {
    --color: ${COLORS[2]};
  }

  &:nth-of-type(4n) {
    --color: ${COLORS[3]};
  }

  &:nth-of-type(5n) {
    --color: ${COLORS[4]};
  }

  &:nth-of-type(6n) {
    --color: ${COLORS[5]};
  }
`;

export const Inner = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacing[3]} ${theme.spacing[4]} ${pxToRem(10)};
    color: ${theme.colors.black};
    text-align: center;
    white-space: nowrap;
    border: ${pxToRem(2)} solid var(--color);
    border-radius: ${pxToRem(100)};
    background-color: ${theme.colors.white};
    transition: background-color ${theme.transitions.short};

    &:hover {
      background-color: var(--color);
    }

    span {
      display: block;
      font-size: ${pxToRem(12)};
      margin-top: ${pxToRem(4)};
      color: ${theme.colors.darkGrey};
    }
  `
);
